module.exports = __webpack_public_path__ + "img/YoshiB.d9427f50.jpg";